<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="dateForDisplay"
        :label="label"
        append-icon="mdi-calendar"
        readonly
        v-on="on"
        hide-details
        dense
        outlined
      >
        <template v-if="date" v-slot:append>
          <v-icon
            @click.prevent="date=''"
            link
          >
            mdi-close
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="menu = false"
      :min="min"
      :max="max"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  props: [
    'value',
    'label',
    'min',
    'max',
  ],

  data: () => ({
    menu: false,
  }),

  computed: {
    date: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    dateForDisplay() {
      return this.date ? moment(this.date).format('D/M/YYYY') : '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DateComponent.vue